import { ReactNode } from 'react';
import styles from './Body.module.scss';

type CardBodyProps = {
  children: ReactNode;
  style?: React.CSSProperties;
};

const CardBody = ({ children, style }: CardBodyProps) => (
  <div className={styles.root} style={style}>
    {children}
  </div>
);

export default CardBody;
